/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { ConfigModuleSchemaRoles } from "src/constants/permissions.constants";
import { normalized } from "src/utils/global";

class Permission {
  constructor() {
  }

  public getPermissionModel(request:any) {
    let requestData = normalized(request);
    let permissionGroup:any = {
      resourceGroupId: requestData?.resourcegroupid,
      displayName: requestData?.displayname,
      resourcesSubGroups: requestData?.resourcessubgroups?.map((subgroup:any) => {
        return {
          resourceSubGroupId: subgroup?.resourcesubgroupid,
          displayName: subgroup?.displayname,
          type: subgroup?.type,
          resources: subgroup?.resources?.map((resource:any) => {
            return {
              resourceId: resource?.resourceid,
              resource: resource?.resource,
              displayName: resource?.displayname,
              actions: resource?.actions?.map((action:any) => {
                return {
                  actionId: action?.actionid,
                  action: action?.action,
                  displayName: action?.displayname,
                }
              })
            }
          })
        };
      })
    }
    return permissionGroup;
  }

  public getListPermissionModel(request:any) {
    let requestData = normalized(request);
    let listPermissionModel:any = requestData?.appresource?.resourcesgroups.map((permissionGroup:any) => {
      return this.getPermissionModel(permissionGroup);
    })
    return listPermissionModel;
  }

  public getSchemaDefaultRoles(request:any) {
    let requestData = normalized(request);
    let currentSchema:any = null;
    requestData?.appresource?.resourcesgroups.forEach((el:any)=> {
      el.resourcessubgroups?.forEach((it:any) => {
        let schema = it.resources?.find((res:any)=>res.resource?.toLowerCase() === ConfigModuleSchemaRoles.RESOURCE_IDENTIFIER);
        if (schema && !currentSchema) {
          currentSchema = {...schema};
        }
      });
    });
    return currentSchema;
  }
}

export default Permission;